import { RouteObject } from "react-router-dom";
import { DevelopmentCommitmentPage } from "src/routes/development-commitments/DevelopmentCommitmentPage";
import { DevelopmentCommitmentsPage } from "src/routes/development-commitments/DevelopmentCommitmentsPage";
import { AppShell } from "src/routing/components/AppShell";
import { BeamNavbarLayout } from "src/routing/components/layouts/BeamNavbarLayout";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import * as commitmentsPaths from "src/routing/domains/developments/commitments/commitmentsPaths";

/**
 * `/development-commitments/*` route trees.
 *
 * Role: data router domain route.
 *
 * Two layout stacks coexist during migration:
 * - **New (Beam):** `AppShell` → `BeamNavbarLayout` → page (list using `PageHeaderLayout`)
 * - **Legacy:** `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page (detail not yet on Beam nav)
 *
 * Path constants live in `commitmentsPaths.ts`.
 */
export const commitmentsRoutes: RouteObject[] = [
  {
    path: commitmentsPaths.developmentCommitmentsRoute.path,
    Component: AppShell,
    children: [
      { Component: BeamNavbarLayout, children: [{ index: true, Component: DevelopmentCommitmentsPage }] },
      {
        Component: GlobalNavLayout,
        children: [
          {
            Component: ScrollableParentLayout,
            children: [
              { path: commitmentsPaths.developmentCommitmentRoute.path, Component: DevelopmentCommitmentPage },
            ],
          },
        ],
      },
    ],
  },
];
